import Variant from './Variant';
export default Variant;
